import React from "react";
import { Input, Label, ToggleFilter } from "uxp/components";
import { IContextData } from "../../../hooks/useContextData";
import { WidgetDesignerPillInput } from "../pill-input/PillInput";

interface IMapTileSource {
    tileUrl?: string;
    mode: 'tile' | 'image';
    imageUrl?: string;
    width?: string;
    height?: string;
}

interface ITileSourcePropertyProps {
    mapTileSource: IMapTileSource;
    onChange: (s: IMapTileSource) => void;
    contextData: IContextData
}

export const MapSourceEditor: React.FunctionComponent<ITileSourcePropertyProps> = (props) => {
    let source = props.mapTileSource;
    function change(k: string, v: any) {
        props.onChange({ ...props.mapTileSource, [k]: v });
    }
    return <div className='map-source-prop-item'>
        <ToggleFilter options={[{ label: 'Tile Server', value: 'tile' }, { label: 'Static Image', value: 'image' }]}
            value={source.mode} onChange={(v) => change('mode', v)} />
        {
            source.mode == 'tile' && <div className='wd-map-item-field'>
                <Label>Tile Server Url</Label>

                <Input
                    value={source.tileUrl || ''}
                    onChange={s => change('tileUrl', s)}
                    className="widget-designer-input"
                />
            </div>
        }
        {
            source.mode == 'image' && <div className='wd-map-item-field'>
                <Label>Image Url</Label>

                <WidgetDesignerPillInput
                    value={source.imageUrl || ''}
                    onChange={s => change('imageUrl', s)}
                    className="widget-designer-input"
                    contextData={props.contextData}
                />
                <Label>Dimensions</Label>
                <div className='wd-map-item-dimensions'>
                    <WidgetDesignerPillInput
                        value={source?.width || ''}
                        onChange={(s) => change('width', s)}
                        contextData={props.contextData}
                    />
                    <span>✕</span>
                    <WidgetDesignerPillInput
                        value={source?.height || ''}
                        onChange={(s) => change('height', s)}
                        contextData={props.contextData}
                    />
                </div>
            </div>
        }
    </div>
};
